var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#whatsapp)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20.9958L5.13434 16.8912C4.43735 15.687 4.07133 14.3213 4.07312 12.9316C4.06505 8.55224 7.63758 4.99585 12.0282 4.99585C14.1592 4.99585 16.1601 5.8183 17.6667 7.31857C18.4093 8.05398 18.9979 8.92878 19.3984 9.89228C19.7989 10.8558 20.0034 11.8888 20 12.9316C20 17.3024 16.4274 20.8588 12.0363 20.8588C10.6997 20.8588 9.39536 20.5279 8.22873 19.8912L4 20.9958ZM8.41534 18.4637L8.65844 18.6088C9.67885 19.2099 10.8426 19.5274 12.0282 19.5282C15.6739 19.5282 18.6472 16.5688 18.6472 12.9391C18.6472 11.1813 17.9587 9.52028 16.7109 8.27857C16.0973 7.66427 15.3676 7.17694 14.5639 6.84466C13.7603 6.51237 12.8985 6.34171 12.0282 6.3425C8.3745 6.34297 5.40214 9.30238 5.40214 12.932C5.40214 14.1738 5.75066 15.3918 6.41493 16.4402L6.56877 16.6903L5.89642 19.1255L8.41581 18.4642L8.41534 18.4637Z",
    fill: "#82858B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0435 9.60914C9.89772 9.27827 9.73581 9.27024 9.59811 9.27024C9.47656 9.2622 9.34646 9.2622 9.20876 9.2622C9.07961 9.2622 8.86072 9.31041 8.67459 9.51225C8.48798 9.7136 7.97803 10.1896 7.97803 11.1652C7.97803 12.1413 8.69073 13.0847 8.78807 13.2138C8.88493 13.3428 10.165 15.407 12.1906 16.2058C13.8753 16.867 14.2157 16.738 14.5804 16.6974C14.9446 16.6572 15.7551 16.2218 15.9251 15.7539C16.087 15.2945 16.087 14.8913 16.0385 14.8104C15.9901 14.7301 15.8519 14.6814 15.6577 14.5765C15.455 14.48 14.483 13.996 14.2969 13.9313C14.1103 13.867 13.9807 13.8348 13.8511 14.0282C13.7214 14.23 13.3406 14.6734 13.2195 14.8024C13.1056 14.9314 12.9845 14.9475 12.7898 14.8506C12.5876 14.7542 11.9475 14.5443 11.1859 13.867C10.5943 13.3423 10.1973 12.6896 10.0758 12.4962C9.96277 12.2944 10.0596 12.1895 10.165 12.0926C10.2543 12.0042 10.3678 11.8591 10.4651 11.7461C10.562 11.6327 10.5943 11.5443 10.6674 11.4152C10.732 11.2862 10.6997 11.1652 10.6513 11.0688C10.6024 10.9799 10.222 10.0038 10.0435 9.60867V9.60914Z",
    fill: "#82858B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "whatsapp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.99585)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ca5ed8e26103c8211c76f232d139985c.svg";
export { ForwardRef as ReactComponent };